var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var buttonElement = require('../components/button');
var ToggleSwitch = require('../components/toggleSwitch');
var permissionModal = modalForm(require('./models/permission'));
var edit = require('../layout/components/edit');
var pathHeader = require('../layout/components/pathHeader');
var equipmentModel = require('../equipment/models/equipment');
var rowActionDropdown = require('../components/rowActionDropdown');
var permissionGroupFilter = require('../libs/permissionGroupFilter');
var pageRequestState = require('../layout/components/pageRequestState');
var page = {};

page.oninit = function () {
  var ctrl = this;

  ctrl.equipmentRecord = prop();
  ctrl.permissions = prop([]);
  ctrl.groups = prop();
  ctrl.fakeNode = prop({'@rid': '01', 'name': 'Permissions'});
  ctrl.routeId = m.route.param('id');
  ctrl.saveError = prop('');
  pageRequestState.initialize(ctrl);

  ctrl.isCurrentRoute = function (routeId) {
    return ctrl.routeId === routeId;
  };

  ctrl.reset = function () {
    ctrl.equipmentRecord(null);
    ctrl.permissions([]);
    ctrl.saveError('');
  };

  ctrl.init = function () {
    var routeId = ctrl.routeId;
    return pageRequestState.run(ctrl, function () {
      return Promise.all([
        loaders.requestWithLoader({
          url: `/api/v1/equipment/${routeId}`,
          method: 'GET',
          background: true
        })
        .then( equipment => {
          if (ctrl.isCurrentRoute(routeId)) {
            ctrl.equipmentRecord(equipment);
            ctrl.equipmentRecord().path.reverse();
            ctrl.equipmentRecord().path.push(ctrl.fakeNode());
          }
        }),
        loaders.requestWithLoader({
          url: '/api/v1/equipment/' + routeId + '/permissions',
          method: 'GET',
          background: true,
        })
        .then(function (records) {
          if (!ctrl.isCurrentRoute(routeId)) {
            return;
          }
          ctrl.permissions(records.map(r => {
            r.dashboard = '#' + routeId;
            r.group = r.in;
            return r;
          }));
        }),
        loaders.requestWithLoader({
          url: '/api/v1/group/',
          method: 'GET',
          background: true
        })
        .then( groups => {
          ctrl.groups(groups);
        })
      ])
      .then(() => {
        if (ctrl.isCurrentRoute(routeId)) {
          m.redraw();
        }
      });
    }, { errorMessage: 'Unable to load equipment permissions:' });
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();


  ctrl.updatePermissions = (permissionRecord, permissionType) => {
    let read = document.getElementById('check_read'+ permissionRecord['@rid']).checked && 
      !document.getElementById('check_read'+ permissionRecord['@rid']).disabled ? 1 : 0;
    let write = document.getElementById('check_write'+ permissionRecord['@rid']).checked && 
      !document.getElementById('check_write'+ permissionRecord['@rid']).disabled ? 1 : 0;
    if (permissionType === 'read' && read === 0) {
      write = 0;
    }
    if (write === 1) {
      read = 1;
    }
    let body = {
      dashboard: permissionRecord.out['@rid'],
      group: permissionRecord.in['@rid'],
      read: read,
      write: write
    }


    Object.keys(body).forEach((key) => {
      if (key.startsWith("parent")) {
        delete body[key];
      }
    });
    
    ctrl.saveError('');
    return loaders.requestWithLoader({
      url: '/api/v1/permission/'+ permissionRecord['@rid'].slice(1),
      method: 'PUT',
      body,
    })
    .then(function () {
      return ctrl.init();
    })
    .catch(function (error) {
      console.error('Unable to update equipment permissions:', error);
      ctrl.saveError((error && (error.error || error.message)) || 'Unable to update permissions. Please try again.');
      m.redraw();
      return null;
    });
  }
};

page.onbeforeupdate = function () {
  var ctrl = this;
  var nextRouteId = m.route.param('id');

  if (!nextRouteId || ctrl.routeId === nextRouteId) {
    return true;
  }

  ctrl.routeId = nextRouteId;
  ctrl.reset();
  ctrl.init();
  return true;
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function (vnode) {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.groups() || !ctrl.equipmentRecord() || !ctrl.equipmentRecord().path) return
  return m('div', {class:'container'}, [
    ctrl.saveError() ? m('div.bg-red.white.pa2.mb2', ctrl.saveError()) : null,
    m(pathHeader, {
      ancestors: ctrl.equipmentRecord().path,
      record: ctrl.fakeNode(),
      class: '.flex.flex-wrap'
    }),
    m('table.fw2.f3.pr4.pb3.narrow',[
      m('thead', [
        m('tr', [
          m('th'),
          m('th.tc.v-btm.fw2.bw1.ph2', {class: 'br bl', colspan: 2}, [
            m('div', [
              m('p', `${ctrl.equipmentRecord().name || ctrl.equipmentRecord()['@class']}`)
            ])
          ]),
        ]),
        m('tr', [
          m('th.tl.f4','Group'),
          //m('th.tl.v-btm.bb.f5.bw1.ph1.w2.bl', 'All'),
          m('th.tl.v-btm.bb.f5.bw1.ph1.w2.br', 'Read'),
          m('th.tl.v-btm.bb.f5.bw1.ph1.w2.bl', 'Write'),
          edit.vm.editing() ? m('th.tl.v-btm.bb.f5.bw1.ph1.w2.bl', 'Actions') : '',
          //m('th.tl.v-btm.bb.f5.bw1.ph1.w2.br', 'Maintenance')
        ])
      ]),
      
      ctrl.permissions().map( permissionRecord =>{
        var equipmentClass = equipmentModel.equipmentClassTree.equipment[ctrl.equipmentRecord()['@class']];
        var parentReadKey = `parent${equipmentClass}Read`;
        var parentWriteKey = `parent${equipmentClass}Write`;
        var inheritedWritePermission = Boolean(permissionRecord.parentWriteAllPermission || permissionRecord[parentWriteKey]);
        var readDisabled = Boolean(permissionRecord.parentReadAllPermission || permissionRecord[parentReadKey] || inheritedWritePermission);
        var writeDisabled = inheritedWritePermission;
        var readChecked = readDisabled ? true : (permissionRecord.read == 1 || permissionRecord.write == 1);
        var writeChecked = writeDisabled ? true : permissionRecord.write == 1;

        return m('tr',[
          m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', permissionRecord.in.name),
          // m('td.bb.bl-0', [
          //   m("label", {class:"switch"}, [
          //     m("input", {type:"checkbox", id:'lamp_test'}),
          //     m("span", {class:"slider"})
          //   ])
          // ]),
          m('td.bb.bl-0', [
            m(ToggleSwitch, {
              id: 'check_read' + permissionRecord['@rid'],
              checked: readChecked,
              disabled: readDisabled,
              ariaLabel: 'Read permission',
              onchange: function () {
                return ctrl.updatePermissions(permissionRecord, 'read');
              }
            })
          ]),
          m('td.bb.bl-0', [
            m(ToggleSwitch, {
              id: 'check_write' + permissionRecord['@rid'],
              checked: writeChecked,
              disabled: writeDisabled,
              ariaLabel: 'Write permission',
              onchange: function () {
                return ctrl.updatePermissions(permissionRecord, 'write');
              }
            })
          ]),
          edit.vm.editing() ?
            m('td.ba.bl-0.tc', [
              m(rowActionDropdown, {
                items: [
                  {
                    label: 'Delete Permission',
                    icon: 'ion-ios-trash',
                    class: 'red',
                    onclick: function () {
                      permissionRecord.name = permissionRecord.in.name;
                      permissionModal.deleteDialogue(permissionRecord);
                    }
                  }
                ]
              })
            ]): ''
        ])
      })
    ]),
    m(buttonElement, {
      label: 'Add Group',
      func: permissionModal.editDialogue.bind(permissionModal, {
        dashboard: ctrl.equipmentRecord()['@rid'],
        read: 0,
        write: 0,
        existingGroupRids: permissionGroupFilter.existingGroupRidsFromPermissions(ctrl.permissions())
      }),
      class: 'btn-default icon-right mt3'
    }),
  ])
}

module.exports = page;
